import _get from 'lodash/get';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import OverlayPlay from '../overlay-play';
import Countdown from '../../countdown';
import Playlist from '../../../models/playlist';
import PlayerSizes from '../../../enum/player-sizes';

class LeaveBehindOverlay extends Component {

    constructor(props) {

        super(props);

    }

    onClickNextClip() {

        event.stopPropagation();
        const {
            playlist,
            onClickNextClip,
        } = this.props;
        const nextitem = playlist.getNextItem();
        playlist.setSelectedItem(nextitem.contentId);
        onClickNextClip(nextitem);

    }

    onClickReplay(event) {

        event.stopPropagation();
        const {
            playlist,
            onClickReplayClip,
        } = this.props;
        onClickReplayClip(playlist.getSelectedItem());

    }

    onCountdownComplete() {

        const {
            playlist,
            onCountdownComplete,
        } = this.props;
        const nextItem = playlist.getNextItem();
        playlist.setSelectedItem(nextItem.contentId);
        onCountdownComplete(nextItem);

    }

    render() {

        const {
            countdown,
            playlist,
            playerSize,
        } = this.props;
        //const current = playlist.getSelectedItem();
        const nextItem = playlist.getNextItem();
        // TODO: Move the poster path normalization into the MediaItem
        const poster = _get(nextItem, 'poster.at3x', _get(nextItem, 'poster.src', ''));
        const title = _get(nextItem, 'title');

        return (
            <div className={`overlay leave-behind-overlay ${playerSize}`} onClick={this.onClickNextClip.bind(this)}>
                <img src={poster} alt={title} />
                <div className="scrim"></div>
                <div className={`overlay-controls ${playerSize}`}>
                    <Countdown
                        countdown={countdown}
                        playlist={playlist}
                        onCountdownComplete={this.onCountdownComplete.bind(this)} />
                    <div className="overlay-title">
                        <h1>{title}</h1>
                    </div>
                    <OverlayPlay classes={playerSize}
                        buttonClasses={playerSize} />
                    <div className="overlay-replay">
                        <button className={playerSize} onClick={this.onClickReplay.bind(this)}>REPLAY</button>
                    </div>
                </div>
            </div>
        );

    }

};

LeaveBehindOverlay.propTypes = {
    /** The the amount of time to count down */
    countdown: PropTypes.number,
    /** The list of media items to playback */
    playlist: PropTypes.instanceOf(Playlist),
    /** Funciton to handle when the countdown is complete. It will pass the next item in the playlist */
    onCountdownComplete: PropTypes.func,
    onClickNextClip: PropTypes.func,
    onClickReplayClip: PropTypes.func,
    /** PlayerSizes enum - the size of the player to help with layout */
    playerSize: PropTypes.string,
};

LeaveBehindOverlay.defaultProps = {
    countdown: 7,
    playlist: new Playlist([]),
    onCountdownComplete: () => null,
    onClickNextClip: () => null,
    onClickReplayClip: () => null,
    playerSize: PlayerSizes.SM,
};

export default LeaveBehindOverlay;
